import { LitElement, html, css } from 'lit'

class ConditionalField extends LitElement {
  #activator
  constructor() {
    super()
    this.visible = false
  }

  firstUpdated() {
      var nestedCondition = this.getAttribute('nested');
      
      this.#activator = document.getElementById(this.for);
      var secondActivator = document.getElementById(nestedCondition);
      const inputs = document.querySelectorAll(`input[name="${this.#activator.name}"]`)
      inputs.forEach((input) => {
        input.addEventListener('change', this.handleChange.bind(this))
      })

    if(secondActivator) {
      var nameOfInput = secondActivator.getAttribute('name');
      
      const nestedInputs = document.querySelectorAll(`input[name="${nameOfInput}"]`)
      nestedInputs.forEach((input) => {
        input.addEventListener('change', this.handleChange.bind(this))
      })
    }
  }

  static properties = {
    visible: { type: Boolean, state: true },
    for: { type: String },
  }

  handleChange(e) {
    // the nested condition is used on the Boka möte form, where two criteria must be met to display Är det en innovativ affärsidé
    var nestedCondition = this.getAttribute('nested');
    
    this.querySelectorAll('input, select, textarea').forEach((field) => {
      if(!nestedCondition) {
        field.disabled = !this.#activator.checked;
      } else if (nestedCondition) {
        var secondActivator = document.getElementById(nestedCondition);
        var nameOfInput = secondActivator.getAttribute('name');
        const inputs = document.querySelectorAll('input[name="'+nameOfInput+'"]')
        
        inputs.forEach((input) => {
          if(input === secondActivator) {
            if(!this.#activator.checked && !input.checked) {
              field.disabled = true;
            } else if(this.#activator.checked && input.checked){
              field.disabled = false;
            }
          } else {
            field.disabled = true;
          }
        })
      }
    })
    
    
    if(!nestedCondition) {
      this.visible = this.#activator.checked;
    } else if (nestedCondition) {
      const inputs = document.querySelectorAll('input[id="'+nestedCondition+'"]')
      
      inputs.forEach((input) => {
        this.visible = this.#activator.checked && input.checked;
      })
    }
    
  }

  render() {
    if (!this.visible) return html``
    return html` <slot></slot> `
  }
}

customElements.define('conditional-field', ConditionalField)

